<template>
  <div @click="openSystem()" class="horizontal tiles-panel" :style="'background: linear-gradient(90deg, ' + item.backgroundColor + ' 0%, rgba(255, 255, 255, 1) 100%)'">
  <!-- <div @click="openSystem()" class="horizontal tiles-panel" :style="`background: ${item.backgroundColor};`"> -->
    <div>
      <div class="horizontal">
        <div :style="'width: 7px; background-color: ' + item.statusColor + '; -webkit-border-top-left-radius: 5px; -webkit-border-bottom-left-radius: 5px; -moz-border-radius-topleft: 5px; -moz-border-radius-bottomleft: 5px; border-top-left-radius: 5px; border-bottom-left-radius: 5px;' "></div>
        <!-- <div :style="'width: 7px; background-color: ' + item.statusColor + ';' "></div> -->
        <div style="margin-top: 12px; margin-bottom: 24px; margin-left: 22px;">
          <div style="  text-overflow: ellipsis; white-space: nowrap; overflow: hidden; max-width: 230px;">
            <span class="big-title">{{item.name}}</span>
          </div>
          <div class="horizontal">
            <div style="width: 130px">
              <div class="vertical" style="margin-top: 3px">
                <span class="small-title">{{ $t('LastUpdate') }}</span>
                <div style="margin-top: -6px;">
                  <img src="@/assets/img/Dashboard/time_clock_circle.svg" />
                  <span class="medium-title" style="font-weight: bold;">{{item.lastUpdateFrom}}</span>
                </div>
              </div>
              <div>
                <span class="small-title">{{ $t('SystemStatus') }}</span>
                <div style="margin-top: -6px;" class="horizontal">
                  <img style="height: 16px; align-self: center;" src="@/assets/img/Dashboard/operation.svg" />
                  <p class="status-description medium-title" style="font-weight: bold;">{{ item.statusDescription }}</p>
                </div>
              </div>
            </div>
            <div style="width: 100px; text-align-last: right;">
              <div class="vertical" style="margin-top: 5px">
                <span class="small-title">{{ $t('CPUTemperature')}}</span>
                <span style="margin-top: -6px;" class="medium-title">{{item.temperature}}°C</span>
              </div>
              <div class="vertical" style="margin-top: 10px">
                <span class="small-title">{{ $t('FreeSpace')}}</span>
                <span v-if="item.freeSpace > 0" style="margin-top: -6px;" class="medium-title">{{item.freeSpace}} GB</span>
                <span v-else-if="item.freeSpace == 0" style="margin-top: -6px;" class="medium-title">{{item.freeSpace}} GB</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    openSystem() {
      this.$router.push({
        name: "settingsGeneral",
        params: {
          systemName: this.item.name,
          systemId: this.item.id,
        },
      });
    }
  },
}
</script>

<style scoped>
.tiles-panel {
  border-radius: 5px;
  padding-right: 13px;
  width: 280px;
  box-shadow: 5px 5px 17px -12px rgba(66, 68, 90, 0.6);
  margin-bottom: 15px;
}
.status-description {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 5px;
  margin-bottom: 0px;
}

.medium-title {
  font-size: 14px;
  color: #5B5C60;
}

.small-title {
  font-size: 10px;
  color: #929499;
}

.big-title {
  font-size: 22px;
  color: #5B5C60;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashboardTile.vue